(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blog-grid')) {
    class BlogGrid extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-blog-grid-list]');
        this.button = this.querySelector('[data-load-more]');
        this.status = this.querySelector('[data-blog-grid-status]');
        if (!this.list || !this.button) return;

        this.handleClick = this.handleClick.bind(this);
        this.button.addEventListener('click', this.handleClick);

        const mode = this.dataset.loadMode;
        if (mode === 'all') this.loadAll();
        if (mode === 'scroll') this.observeFooter();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleClick);
        this.observer?.disconnect();
        this.controller?.abort();
      }

      handleClick(event) {
        event.preventDefault();
        this.loadMore({ moveFocus: true });
      }

      async loadAll() {
        while (this.button && this.isConnected) {
          const loaded = await this.loadMore();
          if (!loaded) break;
        }
      }

      observeFooter() {
        const footer = this.querySelector('[data-load-more-wrapper]');
        if (!footer || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          async ([entry]) => {
            if (!entry.isIntersecting) return;
            const loaded = await this.loadMore();
            if (!loaded || !this.button) return this.observer.disconnect();

            // Re-observe so the next page loads if the footer is still in view.
            this.observer.unobserve(footer);
            this.observer.observe(footer);
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        this.observer.observe(footer);
      }

      async loadMore({ moveFocus = false } = {}) {
        if (this.isLoading || !this.button) return false;
        this.setLoading(true);
        this.controller = new AbortController();

        try {
          const url = new URL(this.button.href);
          url.searchParams.set('section_id', this.dataset.sectionId);

          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const items = [...doc.querySelectorAll('[data-blog-grid-list] > li')];

          this.list.append(...items);
          this.updateButton(doc.querySelector('[data-load-more]'));
          this.announce(`${items.length} more articles loaded`);

          if (moveFocus) items[0]?.querySelector('a')?.focus({ preventScroll: true });
          return true;
        } catch (error) {
          if (error.name !== 'AbortError') {
            console.error('[blog-grid]', error);
            this.announce('More articles could not be loaded. Use the button to open the next page.');
            // Let the link work as a normal page link from now on.
            this.button?.removeEventListener('click', this.handleClick);
          }
          return false;
        } finally {
          this.setLoading(false);
        }
      }

      updateButton(nextButton) {
        if (!nextButton) {
          this.observer?.disconnect();
          this.querySelector('[data-load-more-wrapper]')?.remove();
          this.button = null;
          return;
        }

        const nextUrl = new URL(nextButton.getAttribute('href'), window.location.origin);
        nextUrl.searchParams.delete('section_id');
        this.button.href = nextUrl.toString();
      }

      setLoading(isLoading) {
        this.isLoading = isLoading;
        this.button?.setAttribute('aria-busy', String(isLoading));
      }

      announce(message) {
        if (this.status) this.status.textContent = message;
      }
    }

    customElements.define('blog-grid', BlogGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();
})();
